{
  "alert": {
    "blurb": "Notifikasyon pou atire atansyon itilizatè a.",
    "name": "Atansyon"
  },
  "button": {
    "blurb": "Eleman ou ka klike sou li ki fè yon aksyon lè ou peze l.",
    "default": "Nòmal",
    "loading": "Y ap chaje...",
    "name": "Bouton",
    "send": "Voye"
  },
  "components": {
    "name": "Eleman yo",
    "title": "Eleman yo"
  },
  "form": {
    "blurb": "Demo tout eleman ki pou ou tape yo ki nan modèl sa a.",
    "name": "Fòm",
    "title": "Fòm"
  },
  "orgName": "Devlopman Mindsea",
  "title": "Sandbox Eleman yo"
}
